export var ATTACHED_LABEL_TYPES;
(function (ATTACHED_LABEL_TYPES) {
    ATTACHED_LABEL_TYPES["category"] = "category";
    ATTACHED_LABEL_TYPES["imageGallery"] = "imageGallery";
})(ATTACHED_LABEL_TYPES || (ATTACHED_LABEL_TYPES = {}));
